var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertaVermelho(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16699 11.5003H9.83366V13.167H8.16699V11.5003ZM8.16699 4.83366H9.83366V9.83366H8.16699V4.83366ZM8.99199 0.666992C4.39199 0.666992 0.666992 4.40033 0.666992 9.00033C0.666992 13.6003 4.39199 17.3337 8.99199 17.3337C13.6003 17.3337 17.3337 13.6003 17.3337 9.00033C17.3337 4.40033 13.6003 0.666992 8.99199 0.666992ZM9.00033 15.667C5.31699 15.667 2.33366 12.6837 2.33366 9.00033C2.33366 5.31699 5.31699 2.33366 9.00033 2.33366C12.6837 2.33366 15.667 5.31699 15.667 9.00033C15.667 12.6837 12.6837 15.667 9.00033 15.667Z",
    fill: "#dc3545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertaVermelho);
export default __webpack_public_path__ + "static/media/alerta_vermelho.f4072dd32474806bc20451296f9fe9eb.svg";
export { ForwardRef as ReactComponent };